import { Pipe, PipeTransform } from '@angular/core';
import { AssetDto } from '@nusign/picflow-backend-types';
import { Rect } from '../../classes/rect.class';
import { getAssetVersionDimensions } from '../../gallery/lib/get-asset-version-dimensions';
import { calcContainerSizeForAsset } from '../lib/calc-container-size-for-asset';

@Pipe({
  name: 'crop',
  standalone: true,
  pure: false,
})
export class CropPipe implements PipeTransform {
  transform(
    asset: AssetDto,
    scale: number,
    offsetScale: number,
    windowWidth: number,
    windowHeight: number,
    sideMenuOpen: boolean
  ): Rect {
    const s = offsetScale * scale;
    const { width, height } = getAssetVersionDimensions(asset.version_data);
    const container = calcContainerSizeForAsset(asset, windowWidth, windowHeight, sideMenuOpen);
    const offset = new Rect(); // assuming no offsets
    return new Rect(
      container.width / 2 - (width * s) / 2 + offset.x * scale,
      container.height / 2 - (height * s) / 2 + offset.y * scale,
      width * s,
      height * s
    );
  }
}
